import { EventSourceMessage, fetchEventSource } from "@microsoft/fetch-event-source";
const EventStreamContentType = "text/event-stream";
import { TOKEN_KEY } from "@/config";

export class RetriableError extends Error {}
export class FatalError extends Error {}
export interface PostEventSourceOptions<E = EventSourceMessage> {
  onmessage: (event: E) => void;
  onsuccess?: () => void;
  onerror?: (error: unknown) => void;
  onclose?: () => void;
}

export const postEventSource = <E = EventSourceMessage>(url: string, params: unknown, options: PostEventSourceOptions<E>) => {
  const { onmessage, onsuccess, onerror, onclose } = options;
  const token = localStorage.getItem(TOKEN_KEY);
  const ctrl = new AbortController();
  fetchEventSource(url, {
    openWhenHidden: true,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    method: "POST",
    signal: ctrl.signal,
    // 参数
    body: JSON.stringify(params),
    async onopen(response) {
      if (response.ok && response.headers.get("content-type") === EventStreamContentType) {
        onsuccess?.();
        return;
      }
      // else if (response.status >= 400 && response.status < 500 && response.status !== 429) {
      //   // client-side errors are usually non-retriable:
      //   throw new FatalError();
      // } else {
      //   throw new RetriableError();
      // }
    },
    onmessage(event) {
      onmessage(event as E);
    },
    onerror(error: string | Event) {
      onerror?.(error);
      if (error instanceof FatalError) {
        throw error; // rethrow to stop the operation
      } else {
        // do nothing to automatically retry. You can also
        // return a specific retry interval here.
      }
    },
    onclose() {
      onclose?.();
    },
  });
  return () => {
    ctrl.abort();
  };
};
